module.exports = __webpack_public_path__ + "img/red_029.7984d222.png";